import { BuildClass, Do } from '../../../universal';
import { React } from '../../lib';
import { CJSX } from './meta-types';
import { Modal } from './modal';
import { stubDOMRect, stubInput } from './stubs';
const default_palette = [
    ['#4444FF', '#FF6666', '#F61C1C', '#CCCC00'],
    ['#00CC33', '#EC407A', '#AB47BC', '#7E57C2'],
    ['#5C6BC0', '#FF7043', '#29B6F6', '#26A69A'],
    ['#66BB6A', '#D4E157', '#FFA726', '#8D6E63'],
];
const ColorPickerComponent = (props, ref) => {
    const element = React.useRef(stubInput);
    const [focused, setFocused] = React.useState(false);
    const [closed, setClosed] = React.useState(false);
    React.useImperativeHandle(ref, () => ({
        getElement: () => element.current,
        focus: () => {
            element.current.focus();
        },
        select: () => {
            element.current.select();
        },
    }));
    return (React.createElement("div", { className: BuildClass({
            'ui5-color-picker': true,
            focused: focused && !closed,
            [BuildClass(props.className)]: !!props.className,
        }), title: props.title },
        React.createElement("input", { ref: element, readOnly: true, autoFocus: props.autoFocus, value: props.value ?? '', style: { backgroundColor: getColorValue(props.value) }, onFocus: () => {
                if (!props.readOnly) {
                    setFocused(true);
                    setClosed(false);
                }
            }, onClick: () => {
                if (!props.readOnly) {
                    setClosed(false);
                }
            }, onBlur: () => {
                setFocused(false);
            } }),
        React.createElement(Modal, null,
            React.createElement("div", { className: BuildClass({
                    'ui5-color-picker-modal': true,
                    closed: closed || !focused,
                }), style: Do(() => {
                    const B = element.current?.getBoundingClientRect() ?? stubDOMRect;
                    const x = (B.left + B.right) / 2;
                    const y = B.bottom;
                    return {
                        left: `${x - 134}px`,
                        top: `${y + 1}px`,
                    };
                }) },
                React.createElement(CJSX, { cond: focused && !closed }, (props.colors ?? default_palette).map((x, p) => (React.createElement("div", { className: "col-row", key: p }, x.map((x, q) => (React.createElement("div", { className: "cell", key: q, style: { background: x }, onMouseDown: e => {
                        e.stopPropagation();
                        e.preventDefault();
                    }, onClick: e => {
                        e.stopPropagation();
                        e.preventDefault();
                        props.onUpdate?.(stripHash(x));
                        setClosed(true);
                    } })))))))))));
};
const stripHash = (c) => {
    if (!c) {
        return null;
    }
    if (c.startsWith('#')) {
        return c.substring(1);
    }
    return c;
};
const getColorValue = (value) => {
    let col = value ?? '';
    if (col && !col.startsWith('#')) {
        col = `#${col}`;
    }
    if (col && col.length !== 7) {
        console.warn(`Invalid colour: '${col}'`);
    }
    return col || undefined;
};
export const ColorPicker = React.forwardRef(ColorPickerComponent);
//# sourceMappingURL=color.js.map